import { render } from "./NavigationButtons.vue?vue&type=template&id=e9b0618a&ts=true"
import script from "./NavigationButtons.vue?vue&type=script&lang=ts"
export * from "./NavigationButtons.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__